<template>
  <div class="talent">
    <div class="cjh-title">人才管理</div>

    <div class="cnt" style="padding: 25px">
      <div class="btn-warp">
        <el-form ref="form" :model="searchForm" label-width="100px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="姓名">
                <el-input
                  v-model="searchForm.user_name"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="邮箱">
                <el-input
                  v-model="searchForm.mailbox"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号">
                <el-input
                  v-model="searchForm.mobile"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作单位">
                <el-input
                  v-model="searchForm.work_unit"
                  placeholder="请输入"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="行业领域">
                <!-- <el-input
                  v-model="searchForm.subject_direction"
                  placeholder="请输入"
                  clearable
                ></el-input> -->
                <el-select
                  v-model="searchForm.industry_field"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in hyly"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="性别">
                <el-select
                  v-model="searchForm.sex"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option label="男" value="0"></el-option>
                  <el-option label="女" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="职称">
                <el-cascader
                  filterable
                  v-model="searchForm.professional_technical"
                  :options="zyjszcList"
                  style="width: 100%"
                  clearable
                  :props="{ label: 'positionName', value: 'positionName' }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="政治面貌">
                <el-select
                  v-model="searchForm.political_outlook"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in zzmmList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="学术荣誉">
                <el-select
                  v-model="searchForm.academic_honors"
                  placeholder="请选择"
                  style="width: 100%"
                  clearable
                  filterable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in xsry"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所在地区">
                <el-cascader
                  filterable
                  v-model="searchForm.native_place"
                  :options="jgList"
                  style="width: 100%"
                  clearable
                  :props="{ label: 'name', value: 'name' }"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="人大代表">
                <el-select
                  v-model="searchForm.deputies"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in rddbList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="政协委员">
                <el-select
                  v-model="searchForm.zx_member"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in zxwyList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="审核状态">
                <el-select
                  v-model="searchForm.examine_success_date"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option label="已审核" value="1"></el-option>
                  <el-option label="未审核" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="年龄">
                <el-row>
                  <el-col :span="10">
                    <el-input
                      v-model="searchForm.age_start"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-col>
                  <el-col :span="4">
                    <div
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      至
                    </div>
                  </el-col>
                  <el-col :span="10">
                    <el-input
                      v-model="searchForm.age_end"
                      placeholder="请输入"
                      clearable
                    ></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="获奖情况">
                <el-select
                  v-model="searchForm.provincial_ministerial_level_json"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in jldjList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="专家类型">
                <el-select
                  v-model="searchForm.examine_export_type"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in zjlxList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="曾担任评委">
                <el-select
                  v-model="searchForm.serve_judge"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in drpwList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="填写状态">
                <el-select
                  v-model="searchForm.is_submit"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="(item, index) in txztList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-select
                  v-model="searchForm.is_examine_remark"
                  placeholder="请选择"
                  style="width: 100%"
                  filterable
                  clearable
                >
                  <el-option
                    :label="item.name"
                    :value="item.value"
                    v-for="(item, index) in bzList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <div style="margin-left: 100px">
                <el-button type="primary" @click="handleQuery">查询</el-button>
                <el-button type="primary" @click="handleReset">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-top-warp">
        <el-button type="primary" @click="handleExportPdf">PDF打包下载</el-button>
        <el-button type="primary" @click="handleExport">导出</el-button>
      </div>
      <el-table :data="curTableData" border max-height="500">
        <el-table-column label="序号" width="60">
          <template #default="scope">
            {{ scope.row.id }}
            <!-- {{ getNum(scope.$index) }} -->
          </template>
        </el-table-column>
        <el-table-column prop="user_name" label="姓名"> </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>
        <el-table-column prop="mailbox" label="邮箱"> </el-table-column>
        <el-table-column prop="work_unit" label="单位"> </el-table-column>
        <el-table-column
          prop="examine_export_type"
          label="专家类型"
        ></el-table-column>
        <el-table-column
          prop="examine_number"
          label="证书编号"
        ></el-table-column>
        <el-table-column
          prop="examine_certificate_validity_period"
          label="证书有效期"
        >
        </el-table-column>
        <el-table-column prop="examine_success_date" label="审核通过时间">
        </el-table-column>
        <el-table-column prop="examine_remark" label="备注"> </el-table-column>
        <el-table-column label="操作" width="300">
          <template #default="scope">
            <el-button
              type="primary"
              style="margin-right: 15px"
              @click="handleDetail(scope.row)"
              size="small"
              >详情</el-button
            >
            <el-button
              type="primary"
              style="margin-right: 15px"
              @click="handleSh(scope.row)"
              size="small"
              >审核</el-button
            >
            <el-button
              type="primary"
              style="margin-right: 15px"
              @click="handleBz(scope.row)"
              size="small"
              >添加备注</el-button
            >
            <el-button
              type="primary"
              style="margin-right: 15px; margin-left: 0px"
              @click="handleSj(scope.row)"
              size="small"
              >修改手机号</el-button
            >
            <el-popconfirm
              title="确定删除？"
              @confirm="handleDelete(scope.row)"
            >
              <template #reference>
                <el-button
                  type="primary"
                  style="margin-right: 15px; margin-top: 10px"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>

      <div
        style="display: flex; justify-content: space-between; margin-top: 20px"
      >
        <div class="total-num">当页条数:{{ curTableData?.length }}</div>
        <el-pagination
          background
          layout="total, prev, pager, next"
          :total="total"
          :page-size="15"
          :current-page.sync="page"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="人才详情"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      v-if="dialogVisible"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane label="个人信息" name="first">
          <infoCom :isDis="true"></infoCom>
        </el-tab-pane>
        <el-tab-pane label="主要经历" name="second">
          <experienceCom :isDis="true"></experienceCom>
        </el-tab-pane>
        <el-tab-pane label="科研能力和学术水平" name="third">
          <researchCom :isDis="true"></researchCom>
        </el-tab-pane>
        <el-tab-pane label="在线提交" name="fourth">
          <formSubmitCom :isDis="true"></formSubmitCom>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!-- 审核信息 -->
    <el-dialog
      title="审核信息"
      :visible.sync="shVisible"
      width="30%"
      :before-close="handleClose"
      v-if="shVisible"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item
          label="专家类型"
          prop="examine_export_type"
          :rules="btRules"
        >
          <el-select
            v-model="ruleForm.examine_export_type"
            placeholder="请选择"
            style="width: 100%"
            filterable
            clearable
          >
            <el-option
              :label="item"
              :value="item"
              v-for="(item, index) in zjlxList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书编号" prop="examine_number" :rules="btRules">
          <el-input
            v-model="ruleForm.examine_number"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="证书有效期"
          prop="examine_certificate_validity_period"
          :rules="btRules"
        >
          <el-date-picker
            v-model="ruleForm.examine_certificate_validity_period"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加备注 -->
    <el-dialog
      title="添加备注"
      :visible.sync="bzVisible"
      width="30%"
      :before-close="handleClose"
      v-if="bzVisible"
    >
      <el-form
        :model="ruleForm1"
        ref="ruleForm1"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="备注" prop="examine_remark" :rules="btRules">
          <el-input
            v-model="ruleForm1.examine_remark"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="bzVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleBzSure">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 修改手机号 -->
    <el-dialog
      title="修改手机号"
      :visible.sync="sjVisible"
      width="30%"
      :before-close="handleClose"
      v-if="sjVisible"
    >
      <el-form
        :model="ruleForm2"
        ref="ruleForm2"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="旧手机号" prop="oldMobile" :rules="btRules">
          <el-input
            v-model="ruleForm2.oldMobile"
            disabled
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="新手机号"
          prop="mobile"
          :rules="[
            { required: true, message: '必填', trigger: ['blur', 'change'] },
            {
              pattern: /^1[3-9]\d{9}$/,
              message: '请输入有效的手机号码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="ruleForm2.mobile" placeholder="请输入"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sjVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSjSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  index_class,
  user_list,
  update_user_data,
  user_list_export,
  delete_user,
  download_pdf
} from "../../axios/api";
import area from "./json/area.json";
import technical from "./json/technical.json";
import infoCom from "./info.vue";
import experienceCom from "./experience.vue";
import researchCom from "./research.vue";
import formSubmitCom from "./formSubmit.vue";

export default {
  data() {
    return {
      activeName: "first",
      zyjszcList: technical,
      zjlxList: ["入库专家", "智库专家", "特聘专家", "无"],
      hyly: [],
      drpwList: [],
      rddbList: ["全国人大代表", "地方人大代表"],
      zxwyList: ["全国政协委员", "地方政协委员"],
      txztList: [
        {
          name: "已提交",
          value: "1",
        },
        {
          name: "未提交",
          value: "2",
        },
      ],
      bzList: [
        {
          name: "填写",
          value: "1",
        },
        {
          name: "未填写",
          value: "2",
        },
      ],
      jldjList: [
        "国际学术奖",
        "国家一等奖",
        "国家二等奖",
        "省部特等奖",
        "省部一等奖",
        "省部二等奖",
        "社会力量一等奖",
        "社会力量二等奖",
        "人物奖",
      ],
      zzmmList: [
        "中共党员",
        "中共预备党员",
        "共青团员",
        "民革会员",
        "民盟盟员",
        "民建会员",
        "民进会员",
        "农工党党员",
        "致公党党员",
        "九三学社社员",
        "台盟盟员",
        "无党派人士",
        "群众",
      ],
      xsry: [
        "两院院士",
        "领军人才",
        "长江学者",
        "杰出青年",
        "万人计划",
        "国家奖获奖者(前三完成人)",
      ],
      jgList: area,
      data_type: null,
      btRules: [
        { required: true, message: "必填", trigger: ["blur", "change"] },
      ],
      shVisible: false,
      bzVisible: false,
      sjVisible: false,
      dialogVisible: false,
      title: "新增字典",
      ruleForm: {},
      ruleForm1: {},
      ruleForm2: {},
      curTableData: [],
      searchForm: {
        user_name: null,
        mailbox: null,
        mobile: null,
        work_unit: null,
        subject_direction: null,
        sex: null,
        professional_technical: null,
        political_outlook: null,
        academic_honors: null,
        native_place: null,
        deputies: null,
        zx_member: null,
        examine_success_date: null,
        age_start: null,
        age_end: null,
        provincial_ministerial_level_json: null,
        examine_export_type: null,
        serve_judge: null,
        industry_field: null,
        is_submit: null,
        is_examine_remark: null,
      },
      page: 1,
      total: 0,
      dictList: [
        {
          name: "曾担任评委",
          value: 10,
        },
        {
          name: "行业领域",
          value: 11,
        },
      ],
    };
  },
  components: {
    infoCom,
    experienceCom,
    researchCom,
    formSubmitCom,
  },
  mounted() {
    this.initPage();
    this.getList();
  },
  methods: {
    handleExport() {
      user_list_export({
        token: sessionStorage.getItem("Token3"),
        page: this.page,
        pageSize: 15,
        ...this.searchForm,
        professional_technical: this.searchForm.professional_technical?.length
          ? JSON.stringify(this.searchForm.professional_technical)
          : undefined,
        native_place: this.searchForm.native_place?.length
          ? JSON.stringify(this.searchForm.native_place)
          : undefined,
      }).then((res) => {
        let url = res.data.data.url;
        window.location.href = "http://" + url;
        console.log(res, "ssss");
      });
    },
    handleExportPdf() {
      const loading = this.$loading({
        lock: true,
        text: '系统正在打包中,请耐心等待',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      download_pdf({
        token: sessionStorage.getItem("Token3"),
      }).then((res) => {
        let url = res.data.data.file_url;
        window.location.href = url
      }).finally(() => {
        loading.close();
      })

    },

    getNum(index) {
      return (this.page - 1) * 15 + index + 1;
    },
    handleQuery() {
      this.page = 1;
      this.getList();
    },
    handleReset() {
      this.$refs.form.resetFields();
      this.searchForm = {};
      this.handleQuery();
    },
    currentChange() {
      this.getList();
    },
    handleDetail(row) {
      this.dialogVisible = true;
      sessionStorage.setItem("cjhuser", JSON.stringify(row));
    },
    handleBz(row) {
      this.bzVisible = true;
      this.ruleForm1 = {
        id: row.id,
        examine_remark: row.examine_remark,
      };
    },
    handleBzSure() {
      this.$refs.ruleForm1.validate((valid) => {
        if (valid) {
          update_user_data({
            ...this.ruleForm1,
            token: sessionStorage.getItem("Token3"),
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          });
          this.bzVisible = false;
        } else {
          this.$message({
            message: "请填写完必填项",
            type: "error",
          });
          return false;
        }
      });
    },
    handleSh(row) {
      this.shVisible = true;
      this.ruleForm = {
        id: row.id,
        examine_export_type: row.examine_export_type,
        examine_number: row.examine_number,
        examine_certificate_validity_period:
          row.examine_certificate_validity_period,
      };
    },
    handleSj(row) {
      this.sjVisible = true;
      this.ruleForm2 = {
        id: row.id,
        oldMobile: row.mobile,
        mobile: "",
      };
    },
    handleSjSure() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          update_user_data({
            id: this.ruleForm2.id,
            mobile: this.ruleForm2.mobile,
            token: sessionStorage.getItem("Token3"),
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
            }
          });
          this.getList();
          this.sjVisible = false;
        } else {
          this.$message({
            message: "请填写完必填项",
            type: "error",
          });
          return false;
        }
      });
    },
    handleSure() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          update_user_data({
            ...this.ruleForm,
            token: sessionStorage.getItem("Token3"),
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: "审核通过",
                type: "success",
              });
            }
          });
          this.shVisible = false;
        } else {
          this.$message({
            message: "请填写完必填项",
            type: "error",
          });
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.shVisible = false;
      this.bzVisible = false;
      this.sjVisible = false;
    },
    formatDict(row) {
      let obj = this.dictList.find((item) => item.value === row.data_type);
      return obj?.name;
    },
    initPage() {
      index_class({ token: sessionStorage.getItem("Token3") }).then((res) => {
        if (res.data.code === 200) {
          let dictObj = res.data.data.types || {};
          this.hyly = dictObj[11].map((item) => item.name);
          this.drpwList = dictObj[10].map((item) => item.name);
        }
      });
      this.getList();
    },
    getList() {
      user_list({
        token: sessionStorage.getItem("Token3"),
        page: this.page,
        pageSize: 15,
        ...this.searchForm,
        professional_technical: this.searchForm.professional_technical?.length
          ? JSON.stringify(this.searchForm.professional_technical)
          : undefined,
        native_place: this.searchForm.native_place?.length
          ? JSON.stringify(this.searchForm.native_place)
          : undefined,
      }).then((res) => {
        if (res.data.code === 200) {
          this.total = res.data.data.totalPage;
          this.curTableData = res.data.data.data || [];
        }
      });
    },
    handleDelete(row) {
      delete_user({
        id: row.id,
        token: sessionStorage.getItem("Token3"),
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getList();
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.talent {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  .cjh-title {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    font-weight: 600;
    font-size: 20px;
    flex-shrink: 0;
  }
  .cnt {
    flex: 1;
    overflow-y: auto;
  }
  .btn-warp {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
.table-top-warp {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.total-num {
  font-size: 14px;
  color: #999;
  margin-top: 10px;
  text-align: left;
}
</style>
